import { CALENDARSAVE } from '../../../constants';
import * as Immutable from 'immutable';
const params = {
    info: null
};
const initialState = Immutable.fromJS(params);

/**
 *
 * @param state
 * @param action
 * @returns {*}
 */
export function calendar(state = initialState, action) {
    switch (action.type) {
        case CALENDARSAVE:
            return state.merge({ info: action.data });
        default:
            return state;
    }
}
